// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"48dde4d1","453":"93903c45","732":"214a6fde","977":"f9ffe194"}[chunkId] + ".chunk.js";
};